"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _IconAlertCircle = _interopRequireDefault(require("../../Icons/IconAlertCircle"));

var _MenuLink = _interopRequireDefault(require("../../Menu/MenuLink"));

var _MenuList = _interopRequireDefault(require("../../Menu/MenuList"));

var _MenuText = _interopRequireDefault(require("../../Menu/MenuText"));

var _numbersDigitsToText = require("../../utils/numbersDigitsToText");

var _translationHook = _interopRequireDefault(require("../../utils/translationHook"));

var _excluded = ["errors"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ErrorSummary = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var errors = _ref.errors,
      additionalProps = _objectWithoutProperties(_ref, _excluded);

  var handleOnClickMenuLink = function handleOnClickMenuLink(event, error) {
    event.preventDefault();
    var inputToFocus = document.getElementById(error.inputID);
    var inputToFocusParentRect = inputToFocus.parentElement.previousSibling.getBoundingClientRect();
    inputToFocus.focus();
    window.scroll({
      top: inputToFocusParentRect.y,
      behavior: 'smooth'
    });
  };

  var translatedErrorString = (0, _translationHook.default)({
    EN: "Please correct the following ".concat(errors.length > 1 ? _numbersDigitsToText.englishNumbers[errors.length] || errors.length : '', " ").concat(errors.length > 1 ? 'errors' : 'error', ":"),
    ES: "Por favor corrija ".concat(errors.length > 1 ? 'los siguientes' : 'la siguiente', " ").concat(errors.length > 1 ? _numbersDigitsToText.spanishNumbers[errors.length] || errors.length : '', " ").concat(errors.length > 1 ? 'errores' : 'error', ":")
  }, [errors]);
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: "error-summary"
  }, additionalProps), /*#__PURE__*/_react.default.createElement(_MenuText.default, {
    classes: "error-summary__title",
    element: "h2",
    id: "error-summary__title"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "error-summary__title-icon-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_IconAlertCircle.default, null)), /*#__PURE__*/_react.default.createElement("span", {
    className: "error-summary__text-wrapper",
    tabIndex: -1,
    ref: ref
  }, translatedErrorString)), /*#__PURE__*/_react.default.createElement(_MenuList.default, {
    ariaLabelledBy: "error-summary__title"
  }, errors.map(function (error) {
    return /*#__PURE__*/_react.default.createElement(_MenuLink.default, {
      target: "_self",
      href: "#".concat(error.inputID),
      key: error.inputID,
      ariaLabel: error.ariaLabel,
      dataTestId: error.dataTestId,
      text: error.text,
      icon: "IconChevronDoubleDown",
      clickMethod: function clickMethod(event) {
        return handleOnClickMenuLink(event, error);
      }
    });
  })));
});
ErrorSummary.displayName = 'ErrorSummary';
ErrorSummary.propTypes = {
  /**
   Required. Generates links that jump to corresponding invalid form fields.
   */
  errors: _propTypes.default.arrayOf(_propTypes.default.shape({
    ariaLabel: _propTypes.default.string.isRequired,
    inputID: _propTypes.default.string.isRequired,
    text: _propTypes.default.string.isRequired,
    dataTestId: _propTypes.default.string
  })).isRequired
};
var _default = ErrorSummary;
exports.default = _default;